module.exports = __webpack_public_path__ + "static/media/noah-rosenfield.bd0443bd.jpg";